<div class="divContainer">
  <br />
  <button type="button" style="display:none" id="btnLoadData" (click)="LoadDataList()">LoadData</button>
  <button type="button" style="display:none" id="btnDownload" (click)="Download()">Download</button>
  <div class="row">
    <div class="col-10">
      <div id="divitemList" style="overflow:hidden;overflow-y:auto;">
      </div>
    </div>

    <div class="col-2">
      <div class="row">
        <div class="col">
          <label>Method</label>
          <select id="ddlUploadType" class="form-control">
            <option selected value="0">Select</option>
            <option value="Ingestions">Ingestions</option>
            <option *ngFor="let item of uploadTypeList" value={{item.ApiName}}>
              {{item.ApiName}}
            </option>
          </select>
        </div>

        <div class="col">
          <br />
          <input type="file" id="FU_Attchment" (change)="fileChangeEvent($event)" />
          <em>JrlCode_2024_2349245_2024-06-18_22-13-03.zip</em>
        </div>
        <div class="col">
          <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Upload" (click)="UploadMethod()">Upload</button>
          <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Reset" style="margin-left:10px"
                  (click)="Reset()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
